export const app = (state = {}, action) => {
  switch (action.type) {
    case 'SET_VERSION':
      return {
        version: action.version,
      };
    default:
      return state;
  }
};

export default app;
